var elencosaltacoda_table;
elencosaltacoda_table = $('#elencosaltacoda-table').DataTable({
    language: {
        "sEmptyTable": "Nessun dato presente nella tabella",
        "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
        "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
        "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
        "sInfoPostFix": "",
        "sInfoThousands": ".",
        "sLengthMenu": "Visualizza _MENU_ elementi",
        "sLoadingRecords": "Caricamento...",
        "sProcessing": "Elaborazione...",
        "sSearch": "Cerca:",
        "sZeroRecords": "La ricerca non ha portato alcun risultato.",
        "oPaginate": {
            "sFirst": "Inizio",
            "sPrevious": "Precedente",
            "sNext": "Successivo",
            "sLast": "Fine"
        },
        "oAria": {
            "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
            "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
        }
    },
    dom: 't',
    processing: true,
    serverSide: true,
    ordering: false,
    searching: false,
    autoWidth: true,
    ajax: '/saltacoda/ajax',
    columns: [
        {data: 'nome_cancelleria', name: 'nome_cancelleria'},
        {data: 'n_contatore', name: 'n_contatore'}
    ]
});

$(document).ready(function() {
    $('.create_ticket').click(function() {
        $('#nome').val(null);
        $('#email').val(null);
        $('#myModal').modal({"backdrop": "static"});
    });
    $('#submit_form').click(function() {
        $.ajax({
            type: "POST",
            url: "/ticket/privateStore",
            data: $('#modalform').serialize(),
            success: function(response) {
                swal({
                    title: 'Ticket: '+response.numero_ticket,
                    text: 'Il tuo ticket è stato registrato.',
                    type: 'success',
                    confirmButtonText: 'Ho preso visione!',
                    closeOnConfirm: true,
                });
                $('#myModal').modal('hide');
                elencosaltacoda_table.ajax.reload();
            },
            error: function(response) {
                var result = [];
                var message = '';
                var keys = Object.keys(response.responseJSON);
                keys.forEach(function(key){
                    result.push(response.responseJSON[key]);
                });
                message = result.join('\n');

                swal({
                    title: 'Errore!',
                    text: message,
                    type: 'error'
                });
            }
        });
        return false;
    });
});